document.addEventListener('DOMContentLoaded', () => {
  const mobileMenuBtnEl = document.querySelector('.mobile-menu-button')

  // track media query changes to make sure that menu has a proper height offset and is always visible
  let mediaQuery = window.matchMedia("(max-width: 959px)")
  try {
    // Chrome && Firefox
    mediaQuery.addEventListener('change', (query) => {
      //! close Uncode mobile menu if it's opened when switching from mobile to desktop
      // typical case: switching from portrait to landscape orientation on a tablet
      if (!query.matches && UNCODE.menuOpened && mobileMenuBtnEl) {
        mobileMenuBtnEl.click()
      }
    })
  } catch (e1) {
    try {
      // Safari
      mediaQuery.addListener( (query) => {
        //! close Uncode mobile menu if it's opened when switching from mobile to desktop
        // typical case: switching from portrait to landscape orientation on a tablet
        if (!query.matches && UNCODE.menuOpened && mobileMenuBtnEl) {
          mobileMenuBtnEl.click()
        }
      })
    } catch (e2) {
      console.error(e2);
    }
  }

  // observe menu height changes and postfix Uncode's values if necessary
  const menuWrapper = document.querySelector('.menu-wrapper')
  let observer = new MutationObserver((mutations) => {
    //! set a small timeout to make sure this code is called after Uncode's function
    setTimeout(() => fixMenuHeight(mediaQuery), 50)
  })

  observer.observe(menuWrapper, {
    attributes: true,
    attributeFilter: ['style']
  })
})

/**
 * Fix an Uncode issue where menu height isn't properly calculated, causing an overlap with immediate bottom elements (like breadcrumb).
 *
 * @param query MediaQueryList to check against.
 *
 * @returns void
 */
function fixMenuHeight(query) {
  const mobileMenuEl = document.querySelector('.menu-container-mobile')
  const desktopMenuEl = document.querySelector('#masthead .menu-container')
  const topMenuEl = document.querySelector('.top-menu')
  const menuWrapperEl = document.querySelector('.menu-wrapper')
  let uncodeMenuHeight = 0

  if (mobileMenuEl) {
    uncodeMenuHeight += mobileMenuEl.offsetHeight
  }

  // add desktop menu & top menu height if necessary
  if (!query.matches) {
    uncodeMenuHeight += desktopMenuEl.offsetHeight

    if (topMenuEl) {
      uncodeMenuHeight += topMenuEl.offsetHeight
    }
  }

  // assign new value
  UNCODE.menuHeight = uncodeMenuHeight
  menuWrapperEl.style.height = `${uncodeMenuHeight}px`;

  // dispatch custom event to inform other scripts that menu height has been fixed
  document.dispatchEvent(new CustomEvent('uncode.menu-height.fixed', {
    detail: {
      wrapper: menuWrapperEl,
      newHeight: uncodeMenuHeight
    }
  }))

  // check if menu is properly sticked
  checkMenuStickyState(mobileMenuEl ? mobileMenuEl : desktopMenuEl, query)
}

/**
 * Fix an Uncode issue where sticked menu would sometimes disappear when switching to mobile layout.
 *
 * @param menuEl DOMElement to check
 *
 * @returns void
 */
function checkMenuStickyState(menuEl, query) {
  // stick menu if necessary
  if (query.matches && menuEl.parentElement.classList.contains('is_stuck') && menuEl.style.position !== 'fixed') {
    menuEl.style.position = 'fixed'
  }

  // make sure top offset is always up-to-date (admin bar is thinner on desktop)
  if (menuEl.style.position === 'fixed') {
    const adminBarEl = document.querySelector('#wpadminbar')
    let offsetTop = adminBarEl ? adminBarEl.offsetHeight : 0
    menuEl.style.top = `${offsetTop}px`
  }
}
